import { TypeTradeDataReport } from "src/utils/typings/response/report";

export class TradeDataReports implements IResponseList<TypeTradeDataReport> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: TypeTradeDataReport[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    (this.status_code = 200), (this.data = []);
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}